export default __webpack_public_path__ + "static/media/Contact.da247546.svg";